<template lang="pug">
  .component-policy-button
    .dropdown-buttons
      CouponReveal(:couponProp="item", @itemUpdated="$emit('itemUpdated')")
      //ActionButton(:action="remove") Delete

</template>

<script>
  import PolicyReveal from '../../../../pages/backoffice/PolicyReveal'
  import ModalReveal from '../../foundation/ModalReveal'
  import ActionButton from '../ActionButton'
  import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
  import MaggieHelper from '../../../../maggieHelper'
  import CouponReveal from '../../../../pages/backoffice/CouponReveal'

  export default {
    name: 'CouponButtons',
    components: {CouponReveal, PolicyReveal, ActionButton, ModalReveal},
    data() {
      return {}
    },
    created() {


    },

    methods: {
      remove() {
        return KeplerBackofficeSdk.registrationTokens.select(this.item).remove(() => {
          MaggieHelper.notification('', 'Policy deleted')
          this.$emit('refresh')
        })
      }
    },

    props: ['item']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CouponButtons.vue?3423764f